import { createVariants } from "../theme";
import { BoxProps } from "./box";
import { Col } from "./col";

export type SurfaceVariant =
  | "default"
  | "error"
  | "info"
  | "success"
  | "warning";

export type SurfaceProps = BoxProps & {
  small?: boolean;
  variant?: SurfaceVariant;
};

export function Surface({
  variant = "default",
  small = false,
  style,
  ...rest
}: SurfaceProps) {
  return <Col {...rest} style={[$variant(variant, { small }), style]} />;
}

const $variant = createVariants(
  {
    backgroundColor: "surface",
    borderRadius: "2",
    p: "4",
  },
  {
    default: {
      backgroundColor: "surface",
    },
    error: {
      backgroundColor: "error",
    },
    info: {
      backgroundColor: "info",
    },
    success: {
      backgroundColor: "success",
    },
    warning: {
      backgroundColor: "warning",
    },
  },
  {
    small: {
      p: "2",
    },
  }
);
